import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Gift, Download } from 'lucide-react';

const WeddingsForm = ({ formData, setFormData, onSubmit, isSubmitting }) => {
  const update = (field) => (e) =>
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));

  return (
    <section id="booking-form" className="py-16 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <Gift className="w-16 h-16 mx-auto mb-4 text-[#FDB913]" />
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Book Your Wedding Package</h2>
          <p className="text-lg text-gray-700 mb-2">
            Get Your <strong className="text-[#FDB913]">FREE Wedding Planner PDF</strong> Instantly!
          </p>
          <p className="text-gray-600">
            Fill out the form below and we'll email you the wedding planner right away, plus contact you to discuss your custom wine package.
          </p>
        </div>

        <Card className="border-[#FDB913]/30">
          <CardContent className="pt-8 pb-8">
            <form onSubmit={onSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <Label htmlFor="firstName">First Name *</Label>
                  <Input id="firstName" value={formData.firstName} onChange={update('firstName')} required />
                </div>
                <div>
                  <Label htmlFor="lastName">Last Name *</Label>
                  <Input id="lastName" value={formData.lastName} onChange={update('lastName')} required />
                </div>
              </div>

              <div>
                <Label htmlFor="email">Email *</Label>
                <Input
                  id="email"
                  type="email"
                  value={formData.email}
                  onChange={update('email')}
                  required
                  placeholder="We'll send your FREE Wedding Planner here"
                />
              </div>

              <div>
                <Label htmlFor="phone">Phone Number *</Label>
                <Input id="phone" type="tel" value={formData.phone} onChange={update('phone')} required />
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <Label htmlFor="weddingDate">Wedding Date *</Label>
                  <Input
                    id="weddingDate"
                    type="date"
                    value={formData.weddingDate}
                    onChange={update('weddingDate')}
                    required
                  />
                </div>
                <div>
                  <Label htmlFor="guestCount">Estimated Guest Count *</Label>
                  <Input
                    id="guestCount"
                    type="number"
                    value={formData.guestCount}
                    onChange={update('guestCount')}
                    required
                    placeholder="e.g., 100"
                  />
                </div>
              </div>

              <div>
                <Label htmlFor="message">Tell us about your wedding (Optional)</Label>
                <Textarea
                  id="message"
                  value={formData.message}
                  onChange={update('message')}
                  rows={4}
                  placeholder="Package preference, wine choices, special requests..."
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="referralCode" className="text-gray-700">
                  Referral Code (Optional)
                </Label>
                <Input
                  id="referralCode"
                  type="text"
                  placeholder="Enter referral code if you have one"
                  value={formData.referralCode}
                  onChange={update('referralCode')}
                  className="border-gray-300"
                />
              </div>

              <div className="bg-[#FDB913]/10 border border-[#FDB913]/30 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <Download className="w-5 h-5 text-[#FDB913] flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold text-gray-900 mb-1">What You'll Get:</p>
                    <ul className="text-sm text-gray-700 space-y-1">
                      <li>✓ FREE Wedding Planner PDF emailed instantly</li>
                      <li>✓ Personal consultation call within 24 hours</li>
                      <li>✓ Custom quote for your wedding package</li>
                    </ul>
                  </div>
                </div>
              </div>

              <Button
                type="submit"
                data-track="weddings:wedding_form_submit"
                className="w-full bg-[#FDB913] hover:bg-[#E5A50A] text-gray-900 font-semibold text-lg py-6"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Book Now & Get FREE Wedding Planner'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default WeddingsForm;
